import React from 'react';
import { Stack, Typography } from '@mui/material';
import TimelineEntryAttribution from '../../components/Timeline/TimelineEntryAttribution';
import { getCaregiverDisplayName } from '../../components/Timeline/utils/timelineCaregiverLabels';
import { getUserDetails } from '../../services/users/userService';

const getAuthorId = (source) => source.createdBy || source.authorId || source.capturedBy?.id
  || (typeof source.capturedBy === 'string' ? source.capturedBy : '');

const CaptureAuthor = ({ source }) => {
  const name = getCaregiverDisplayName(source);
  const uid = getAuthorId(source);
  const [profile, setProfile] = React.useState(null);

  React.useEffect(() => {
    let active = true;
    if (!name && uid) {
      getUserDetails(uid).then((user) => {
        if (active) setProfile({ uid, name: user?.uid === uid && user.displayName !== 'Unknown User' ? user.displayName : '' });
      }).catch(() => { if (active) setProfile({ uid, name: '' }); });
    }
    return () => { active = false; };
  }, [name, uid]);

  if (!name && uid && profile?.uid !== uid) {
    return <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>Loading author…</Typography>;
  }

  return <TimelineEntryAttribution entry={{
    ...source,
    authorName: name || (profile?.uid === uid ? profile.name : ''),
  }} />;
};

const CaptureSourceAttribution = ({ sources = [] }) => {
  const authors = new Map();
  sources.forEach((source) => {
    const key = getAuthorId(source) || getCaregiverDisplayName(source) || 'unknown';
    if (!authors.has(key)) authors.set(key, source);
  });

  return <Stack spacing={0.25} sx={{ mb: 0.75 }}>
    {[...authors].map(([key, source]) => <CaptureAuthor key={key} source={source} />)}
  </Stack>;
};

export default CaptureSourceAttribution;
